import React, {useEffect, useState} from 'react';
import {Box, Dialog, DialogActions, DialogContent, DialogTitle, Pagination, Typography} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {getCheckins} from '../actions';
import CheckinsTable from '../components/CustomTables/CheckinsTable';
import {Filters} from '../components';
import useFilters from '../utils/useFilters';
import { getInvalidStatusCards } from '../actions/reportsActions';
import { Button } from 'rsuite';

const CheckinsPage = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);  
  const [alertMessage, setAlertMessage] = useState('');  
  const {checkins, checkinsPage, checkinsTotalPages, reportsLoading, invalidStatusCards , inactiveStatusCardsLoading} =
    useSelector(s => s.reports);
  // Check-ins are only loaded once an elevator is selected (the unfiltered query
  // spans the whole 16M-row check_in table).
  const filters = useFilters(val => {
    if (val.elevatorId) dispatch(getCheckins(val));
  }, 'imei');
  const hasElevator = !!filters.elevator;

  const onPageChange = (e, value) => {
    dispatch(getCheckins({page: value, ...filters.filters}));
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getInvalidStatusCards());
  }, []);

  useEffect(() => {
    if (invalidStatusCards && invalidStatusCards.length > 0) {
      const message = invalidStatusCards.join('\n');
      setAlertMessage(message);
      setOpen(true);  
    }
  }, []);

  return (
    <>
      <Filters
        withSearch
        withElevator
        withDateRange
        withCustomer
        searchLabel="Search by IMEI"
        {...filters}
      />
      {hasElevator ? (
        <CheckinsTable checkins={checkins} loading={reportsLoading} />
      ) : (
        <Box mt="2rem" textAlign="center">
          <Typography color="textSecondary">
            Select an elevator to see its check-ins.
          </Typography>
        </Box>
      )}
      {hasElevator && checkinsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={checkinsTotalPages}
            page={checkinsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Alert : Inactive Cards Being Used</DialogTitle>
        <DialogContent>
        <pre style={styles.alertMessage}>{alertMessage}</pre>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CheckinsPage;


const styles = {
  alertMessage: {
    backgroundColor: '#f8d7da', 
    color: '#721c24',           
    borderRadius: '4px',
    padding: '10px 20px',
    // fontFamily: '"Courier New", Courier, monospace', 
    whiteSpace: 'pre-wrap',      
    wordWrap: 'break-word',     
    border: '1px solid #f5c6cb', 
    fontSize: '14px',            
    overflowX: 'auto',           
  },
};